import { memo } from "react";
import { ButtonIconPlain } from "../plain/ButtonIconPlain";
import { DATA_TABLE_TOOLTIP_ID } from "../layout/DataTableTooltip";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { ModalRunProgress } from "../modals/ModalRunProgress/ModalRunProgress";

interface CellRendererRunLogsProps {
  rowId: string;
}

/**
 * Cell renderer for a button to view the logs of a workflow run
 */
const CellRendererRunLogs = ({ rowId }: CellRendererRunLogsProps) => {
  const { openModal, closeModal } = useModalContext();

  const showModal = () =>
    openModal(
      <ModalRunProgress rowId={rowId} initialTab="LOGS" onClose={closeModal} />,
    );

  return (
    <ButtonIconPlain
      aria-label="View run logs"
      color="primary"
      iconSize="m"
      iconType="tableDensityExpanded"
      onClick={showModal}
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-content="View run logs"
    />
  );
};

export const CellRendererRunLogsMemo = memo(CellRendererRunLogs);
